export const CLIENTS = "ClientIDs";
export const CLIENT_ID = "ClientID";
export const CLIENT_FIRST_NAME = "FirstName";
export const CLIENT_LAST_NAME = "LastName";
export const CLIENT_MOBILE = "Mobile";
export const CLIENT_EMAIL = "Email";
